import {CLASSES, EVENTS} from '../DNFORM-utils/DNFORM-constants';

export const validationMixin = {
	data() {
		return {
			EVENTS,
			warnOnPageLeave: false
		};
	},
	watch: {
		currentStep() {
			// Because of the required_if rule we have to update the validation rules when the step changes
			this.extendValidation(this.validation, true);
		}
	},
	methods: {
		extendValidation(model, isFirstLoop = false) {
			const currentModel = isFirstLoop ? model[this.currentStep] : model;

			for (const key in currentModel) {
				if (typeof currentModel[key] == 'object' && currentModel[key] !== null) {
					if (Object.keys(currentModel[key]).includes('required_if') && Object.values(currentModel[key])[0].length === 1) {
						// eslint-disable-next-line camelcase
						const extendedRequiredIfObject = {required_if: [...Object.values(currentModel[key])[0], this.model[this.currentStep]]};
						currentModel[key] = extendedRequiredIfObject;
					} else {
						this.extendValidation(currentModel[key]);
					}
				}
			}
		},
		onBlur(field, controlledFields) {
			if (controlledFields && controlledFields.length) {
				this.handleDynamicFieldValidation(field, controlledFields, EVENTS.BLUR);
			}

			this.validateInput(field);
		},
		onInput(field, controlledFields) {
			if (controlledFields && controlledFields.length) {
				this.handleDynamicFieldValidation(field, controlledFields, EVENTS.INPUT);
			}

			const isFieldTouched = this.isFieldTouched(field);

			if (isFieldTouched || this.errors.allTouched) {
				this.validateInput(field);
			}
		},
		onDateInput(date, field) {
			this.model[this.currentStep][field] = date;
			this.validateInput(field);
		},
		validateInput(field) {
			this.turnOnPageLeaveWarning();
			this.$livr.validate({[field]: this.validation[this.currentStep][field]}, {[field]: this.model[this.currentStep][field]}, field);
		},
		validateForm() {
			this.$livr.validateAll(this.validation[this.currentStep], this.model[this.currentStep]);
		},
		isFieldTouched(field) {
			return !!this.errors.touchedFields[field];
		},
		handleDynamicFieldValidation(controlField, controlledFields, event) {
			// Validate the controlled fields if necessary
			controlledFields.forEach((field) => {
				if (event === EVENTS.BLUR) {
					this.validateInput(field);
				} else if (event === EVENTS.INPUT) {
					const isControlledFieldTouched = this.isFieldTouched(field);

					if (isControlledFieldTouched || this.errors.allTouched) {
						this.validateInput(field);
					}
				}
			});
		},
		hasError(inputId, errorCode) {
			let result = false;
			
			if (errorCode) {
				result = this.errors.items[inputId] && this.errors.items[inputId] === errorCode;
			} else {
				result = this.errors.items[inputId];
			}

			return result;
		},
		scrollToFirstInvalidInput() {
			const form = this.$refs[this.formId];

			if (form) {
				const invalidInput = form.querySelector(CLASSES.INVALID_INPUT);

				if (invalidInput) {
					invalidInput.scrollIntoView({behavior: 'smooth'});
					invalidInput.focus({preventScroll: true});
				}
			}
		},
		turnOnPageLeaveWarning() {
			if (!this.warnOnPageLeave) {
				this.warnOnPageLeave = true;
			}
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/DNFORM/DNFORM-mixins/DNFORM-validation-mixin.js